// Holds the cliente resolved at login so ClienteIntakeHome never re-queries by
// phone digits. Mirrored into sessionStorage so a refresh mid-demo does not
// dump the exec back on the login card.
//
// This is NOT authentication. There is no Supabase session on the cliente side
// yet — the value here is a convenience handle, and every query it feeds is
// still subject to RLS. When cliente auth becomes real (phone + OTP), this
// context should read from the session instead of sessionStorage.

import { createContext, useCallback, useContext, useMemo, useState } from 'react';

const STORAGE_KEY = 'desarrollos_current_client';

const ClienteContext = createContext(null);

const readStored = () => {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const ClienteProvider = ({ children }) => {
  const [cliente, setClienteState] = useState(readStored);

  const setCliente = useCallback((next) => {
    setClienteState(next);
    try {
      if (next) sessionStorage.setItem(STORAGE_KEY, JSON.stringify(next));
      else sessionStorage.removeItem(STORAGE_KEY);
    } catch {
      // Private-mode Safari throws on sessionStorage writes. In-memory state
      // still works for the session; only refresh-persistence is lost.
    }
  }, []);

  const value = useMemo(() => ({ cliente, setCliente }), [cliente, setCliente]);

  return <ClienteContext.Provider value={value}>{children}</ClienteContext.Provider>;
};

export const useCliente = () => {
  const ctx = useContext(ClienteContext);
  if (!ctx) throw new Error('useCliente debe usarse dentro de <ClienteProvider>');
  return ctx;
};
